(function ($) {
    'use strict';

    $( document ).ready( function () {

        const $toggle_button = $( '.om-property__description-toggle' );
        const $more_info     = $( '#om-property-description-more' );

        if ( $toggle_button.length && $more_info.length ) {
            $toggle_button.on( 'click', function () {
                const is_expanded = 'true' === $toggle_button.attr( 'aria-expanded' );
                $toggle_button.attr( 'aria-expanded', String( ! is_expanded ) );
                $more_info.attr( 'aria-expanded', String( ! is_expanded ) );

                if ( is_expanded ) {
                    $more_info.css( 'maxHeight', $more_info.css( 'minHeight' ) );
                } else {
                    $more_info.css( 'maxHeight', $more_info[0].scrollHeight + 'px' );
                }
            } );
        }

        $( '.om-property__feature-body li b' ).each( function () {
            const $more    = $( this ).find( '.om-property-item-more' );
            const $trigger = $( this ).find( '.om-property-items-more' );

            if ( ! $more.length || ! $trigger.length ) {
                return;
            }

            $trigger.data( 'count', $trigger.text().replace( '+', '' ) );

            $trigger.on( 'click', function () {
                const is_expanded = $more.css( 'display' ) !== 'none';
                $more.css( 'display', is_expanded ? 'none' : 'flex' );
                $trigger.text( is_expanded ? '+' + $trigger.data( 'count' ) : 'Minder' );
            } );
        } );

        const $gallery_toggle = $( '.om-property__gallery-toggle' );
        const $gallery_rest   = $( '.om-property__gallery-rest' );

        if ( $gallery_toggle.length && $gallery_rest.length ) {
            $gallery_toggle.on( 'click', function () {
                const is_expanded = 'true' === $gallery_toggle.attr( 'aria-expanded' );
                $gallery_toggle.attr( 'aria-expanded', String( ! is_expanded ) );

                $( '.om-property__gallery-overflow' ).css( 'display', is_expanded ? 'flex' : 'none' );
                $gallery_rest.css( 'display', is_expanded ? 'none' : 'grid' );
            } );
        }

    } );
})( jQuery );